<template>
  <CFooter :fixed="false">
    <div>
      CargoMX
      <span class="ml-1">&copy; 2024.</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
